module.exports = __webpack_public_path__ + "static/img/profile-icon15.8f3e5fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/profile-icon15.png
// module id = 2963
// module chunks = 1